module.exports = __webpack_public_path__ + "static/media/sj-1.6413af36.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sj-1.jpeg
// module id = 119
// module chunks = 0